import React, { useEffect, useState } from "react";
import { Modal, Spin } from "antd";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Skeleton from "@mui/material/Skeleton";
import ProductExpireTable from "../Tables/ProductExpiryTable";

const ProductExpiryModal = ({ open, onClose, id }) => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [expiryData, setExpiryData] = useState([]);
  const userData = useSelector((state) => state?.login?.user?.result);
  const [productName, setProductName] = useState("")
  const [productBarcode, setProductBarcode] = useState("")


  useEffect(() => {
    if (open && id) {
      GetProductExpiryData();
    }
  }, [open, id]);

  const GetProductExpiryData = async (limit, offset) => {
    const payload = {
      "company_id": userData?.company_id,
      "product_id": Number(id),
      "limit": limit,
      "offset": offset
    };


    try {
      const res = await axiosInstance.post(URLS.GET_PRODUCT_EXPIRY, payload);
      const res1 = res?.data;

      console.log("res1---->", res1);

      if (res1?.result?.status_code === 200) {
        setExpiryData(res1?.result?.data);
        setProductName(res1?.result?.data[0].product_name)
        setProductBarcode(res1?.result?.data[0].product_barcode)

      }
      else {
        setExpiryData([])
        setProductName(res1?.result?.data.product_name)
        setProductBarcode(res1?.result?.data.product_barcode)
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    } finally {

      setLoading(false);
    }
  };


  console.log(expiryData)


  return (
    <Modal
      open={open}
      onCancel={() => {
        setExpiryData([]);
        onClose();
      }}
      footer={null}
      width={1400}
      height={700}
      centered
      closable={true}
      title={
        <div className="text-2xl font-semibold mb-7">
          {t("Product Information")}
        </div>
      }
    >

      {loading ? (
        Array.from({ length: 4 }).map((_, index) => (
          <div
            key={index}
            className="flex px-4 py-3 border-b justify-between items-center"
          >
            <Skeleton height={50} width={300} />
            <Skeleton height={50} width={60} />
            <Skeleton height={50} width={60} />
          </div>
        ))
      ) : (
        <div className="mt-6 bg-white rounded-lg">

          <div className="w-full border border-gray-200 rounded-lg p-4 mb-4">            
            <div className="space-y-2  gap-4 justify-center items-center">
            <p className="text-md" style={{ fontSize: "20px" }}>
              <span className="font-semibold text-gray-700">
                {t("Product Barcode")}:
              </span>{" "}
              <span className="text-gray-900">
                {productBarcode}
              </span>
            </p>

            <p className="text-md" style={{ fontSize: "20px" }}>
              <span className="font-semibold text-gray-700">
                {t("Product Name")}:
              </span>{" "}
              <span className="text-gray-900">
                {productName}
              </span>
            </p>
          </div>
          </div>

          <ProductExpireTable
            additionalData={expiryData}
            pagination={(values) => {
              // setCurrentLimit(values.limit);
              // setCurrentOffset(values.offset);
              GetProductExpiryData(values.limit, values.offset);
            }}
          />
        </div>
      )}
    </Modal>

  );
};

export default ProductExpiryModal;
